import React, { FC } from 'react';
// icons
import { BsQuestionDiamond } from 'react-icons/bs';

// components
import AampeIconBackground from '../../../../components/shared/AampeIconBackground/AampeIconBackground';
import styled from 'styled-components';

// theme
import aampeTheme from '../../../../constants/aampeTheme';

interface TestFormulaNotifyProps {
    message: string;
}

const TestFormulaNotify: FC<React.PropsWithChildren<TestFormulaNotifyProps>> =
    ({ message }) => {
        return (
            <>
                <AampeIconBackground
                    primaryColor={aampeTheme.colors.primary50}
                    secondaryColor={aampeTheme.colors.primary100}
                >
                    <BsQuestionDiamond color={aampeTheme.colors.solidA01} />
                </AampeIconBackground>
                <Paragraph>{message}</Paragraph>
            </>
        );
    };

const Paragraph = styled.p(() => ({
    fontSize: '14px',
    textAlign: 'center',
    fontWeight: 500,
    color: aampeTheme.colors.solidA01,
}));

export default TestFormulaNotify;
